import { connect } from 'react-redux';
import CheckoutMobileDetails from './CheckoutMobileDetails';

const mapStateToProps = ({ global, searchCars, siteConfiguration }) => ({
  listAdditionals: global.listAdditionals,
  settings: siteConfiguration.settings,
  searchCars,
});

export default connect(mapStateToProps)(CheckoutMobileDetails);
